export default __webpack_public_path__ + "static/media/antelope-8-thumbnail.5ac9a38c.jpg";